import { navigate } from 'gatsby'
import { auth } from 'utils/firebase'

export const logout = async () => {
  await auth?.signOut()
  navigate('/')
}
